<style lang="less">
.zzl-api-params {
  .zzl-api-params-trigger {
    display: flex;
    align-items: center;
    gap: 6px;
    min-height: 25px;
    padding: 0 28px 0 8px;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    border-radius: 3px;
    transition: background 0.15s, color 0.15s;

    &:hover:not(.disabled) {
      background: rgba(45, 140, 240, 0.06);
    }

    &.disabled {
      cursor: not-allowed;
    }

    &.filled {
      color: var(--primary);
    }

    &.empty {
      color: #aaa;
    }
  }

  .zzl-api-params-trigger-icon {
    flex-shrink: 0;
    font-size: 14px;
    opacity: 0.85;
  }

  .zzl-api-params-trigger-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.zzl-api-params-modal {
  padding: 0;
}

.zzl-api-params-summary {
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: linear-gradient(180deg, #fafbfc 0%, #f5f7fa 100%);
}

.zzl-api-params-summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.zzl-api-params-summary-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text2, #333);
}

.zzl-api-params-summary-count {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(45, 140, 240, 0.1);
  color: var(--primary);
  font-size: 11px;
  font-weight: 500;
}

.zzl-api-params-progress {
  height: 4px;
  border-radius: 2px;
  background: #e8eaec;
  overflow: hidden;
}

.zzl-api-params-progress-bar {
  height: 100%;
  border-radius: 2px;
  background: var(--primary);
  transition: width 0.25s ease;
}

.zzl-api-params-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 36px 16px;
  color: var(--subtext2);
  font-size: 12px;
  border: 1px dashed var(--border);
  border-radius: 6px;
  background: #fafbfc;
}

.zzl-api-params-empty-icon {
  font-size: 28px;
  color: #c5c8ce;
}

.zzl-api-params-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 420px;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 2px;
}

.zzl-api-param-item {
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: rgba(45, 140, 240, 0.35);
  }

  &.filled {
    border-color: rgba(45, 140, 240, 0.45);
    box-shadow: 0 1px 4px rgba(45, 140, 240, 0.08);
  }
}

.zzl-api-param-head {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #f8f9fb;
  border-bottom: 1px solid var(--border);
}

.zzl-api-param-label {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--text2, #333);
  word-break: break-word;
}

.zzl-api-param-key {
  flex-shrink: 0;
  padding: 1px 6px;
  border-radius: 3px;
  background: #eef0f3;
  color: var(--subtext2);
  font-size: 10px;
  font-family: Consolas, Monaco, monospace;
}

.zzl-api-param-status {
  flex-shrink: 0;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;

  &.filled {
    background: rgba(25, 190, 107, 0.12);
    color: #19be6b;
  }

  &.empty {
    background: #f0f0f0;
    color: #aaa;
  }
}

.zzl-api-param-req {
  flex-shrink: 0;
  color: var(--error);
  font-weight: 600;
}

.zzl-api-param-desc {
  padding: 6px 12px 0;
  color: var(--subtext2);
  font-size: 11px;
  line-height: 1.5;
}

.zzl-api-param-body {
  padding: 10px 12px 12px;

  .fps-wrap {
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }
}

.zzl-api-params-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.zzl-api-params-footer-tip {
  font-size: 11px;
  color: var(--subtext2);
}

.zzl-api-params-footer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
</style>

<template>
  <div class="pd-embed-control zzl-api-params" :class="{ 'pd-embed-control-disabled': !editable }">
    <div
      class="zzl-api-params-trigger"
      :class="{ filled: filledCount > 0, empty: !filledCount, disabled: !editable }"
      @click="openModal"
    >
      <Icon type="md-settings" class="zzl-api-params-trigger-icon" />
      <span class="zzl-api-params-trigger-text">{{ triggerLabel }}</span>
    </div>

    <Modal
      v-model="modalOpen"
      :width="720"
      title="接口参数配置"
      footer-hide
      class-name="zzl-api-params-modal-wrap"
      @on-visible-change="onModalVisible"
    >
      <div class="zzl-api-params-modal">
        <div v-if="!paramDefs.length" class="zzl-api-params-empty">
          <Icon type="md-information-circle" class="zzl-api-params-empty-icon" />
          <span>该接口暂无参数</span>
        </div>

        <template v-else>
          <div class="zzl-api-params-summary">
            <div class="zzl-api-params-summary-head">
              <div class="zzl-api-params-summary-title">
                <Icon type="md-options" />
                <span>参数配置</span>
              </div>
              <span class="zzl-api-params-summary-count">
                {{ draftFilledCount }}/{{ paramDefs.length }} 已填
              </span>
            </div>
            <div class="zzl-api-params-progress">
              <div
                class="zzl-api-params-progress-bar"
                :style="{ width: `${progressPercent}%` }"
              />
            </div>
          </div>

          <div class="zzl-api-params-list">
            <div
              v-for="p in paramDefs"
              :key="p.key"
              class="zzl-api-param-item"
              :class="{ filled: isDraftFilled(p) }"
            >
              <div class="zzl-api-param-head">
                <span class="zzl-api-param-label">{{ paramLabel(p) }}</span>
                <span v-if="p.config && p.config.required" class="zzl-api-param-req">*</span>
                <span class="zzl-api-param-key">{{ p.key }}</span>
                <span
                  class="zzl-api-param-status"
                  :class="isDraftFilled(p) ? 'filled' : 'empty'"
                >
                  {{ isDraftFilled(p) ? '已填' : '未填' }}
                </span>
              </div>
              <div v-if="p.config && p.config.description" class="zzl-api-param-desc">
                {{ p.config.description }}
              </div>
              <div class="zzl-api-param-body">
                <component
                  :is="resolveControl(p.control)"
                  :value="draftValues[p.key]"
                  :config="p.config || {}"
                  :option="p.config || {}"
                  :editable="editable"
                  :platform="platform"
                  @input="setDraftValue(p.key, $event)"
                />
              </div>
            </div>
          </div>
        </template>

        <div v-if="paramDefs.length" class="zzl-api-params-footer">
          <span class="zzl-api-params-footer-tip">带 * 为必填参数</span>
          <div class="zzl-api-params-footer-actions">
            <Button size="small" @click="handleClear">清除</Button>
            <Button size="small" @click="handleCancel">取消</Button>
            <Button type="primary" size="small" @click="handleSave">确定</Button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import FormPositionSelect from '@/components/form/zzl/extra/FormPositionSelect.vue';

/** 参数控件映射：control 字段 -> 渲染组件 */
const CONTROL_MAP = {
  FormPositionSelect,
  Select: 'ParamSelect',
  Input: 'ParamInput',
};

const ParamInput = {
  name: 'ParamInput',
  props: {
    value: {},
    config: { type: Object, default: () => ({}) },
    editable: { type: Boolean, default: true },
  },
  template: `
    <Input
      :value="value"
      size="small"
      :disabled="!editable"
      :placeholder="config.placeholder || '请输入'"
      :type="config.type || 'text'"
      :number="!!config.number"
      @input="$emit('input', $event)"
    />
  `,
};

const ParamSelect = {
  name: 'ParamSelect',
  props: {
    value: {},
    config: { type: Object, default: () => ({}) },
    editable: { type: Boolean, default: true },
  },
  computed: {
    options() {
      const opts = (this.config && this.config.options) || [];
      if (!opts.length) return [];
      if (typeof opts[0] === 'object') {
        return opts.map((o) => ({
          label: o.label != null ? o.label : o.name,
          value: o.value != null ? o.value : o.key,
        }));
      }
      return opts.map((v) => ({ label: v, value: v }));
    },
  },
  template: `
    <Select
      :value="value"
      size="small"
      transfer
      clearable
      :disabled="!editable"
      :placeholder="config.placeholder || '请选择'"
      :multiple="!!config.multiple"
      style="width: 100%"
      @input="$emit('input', $event)"
    >
      <Option v-for="o in options" :key="o.value" :value="o.value">{{ o.label }}</Option>
    </Select>
  `,
};

function emptyFormPosition() {
  return {
    presetForm_fID: '',
    targetContent: '',
    targetItem: '',
  };
}

function hasParamValue(v, control) {
  if (v === undefined || v === null || v === '') return false;
  if (control === 'FormPositionSelect' && typeof v === 'object') {
    return !!(v.presetForm_fID || v.targetContent || v.targetItem);
  }
  if (Array.isArray(v)) return v.length > 0;
  return true;
}

function defaultValueFor(control, config) {
  if (control === 'FormPositionSelect') return emptyFormPosition();
  if (config && config.default !== undefined) return cloneDeep(config.default);
  if (control === 'Select' && config && config.multiple) return [];
  return '';
}

export default {
  name: 'ZZLAPIParamsEditor',
  components: {
    FormPositionSelect,
    ParamInput,
    ParamSelect,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    db: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalOpen: false,
      draftValues: {},
    };
  },
  computed: {
    paramDefs() {
      const list = (this.option && this.option.params) || [];
      return Array.isArray(list) ? list.filter((p) => p && p.key) : [];
    },
    platform() {
      return (
        (this.option && this.option.platform)
        || (this.db && this.db.platform)
        || (this.$route && this.$route.query && this.$route.query.platform)
        || 'pmis'
      );
    },
    filledCount() {
      return this.paramDefs.filter((p) => hasParamValue(this.value && this.value[p.key], p.control)).length;
    },
    draftFilledCount() {
      return this.paramDefs.filter((p) => hasParamValue(this.draftValues[p.key], p.control)).length;
    },
    progressPercent() {
      if (!this.paramDefs.length) return 0;
      return Math.round((this.draftFilledCount / this.paramDefs.length) * 100);
    },
    triggerLabel() {
      if (!this.paramDefs.length) return '无参数';
      if (!this.filledCount) return `点击配置 (0/${this.paramDefs.length})`;
      return `已配置 ${this.filledCount}/${this.paramDefs.length}`;
    },
  },
  watch: {
    paramDefs: {
      handler() {
        this.ensureValueShape();
      },
      deep: true,
    },
  },
  methods: {
    resolveControl(control) {
      return CONTROL_MAP[control] || CONTROL_MAP.Input;
    },
    paramLabel(p) {
      const cfg = p.config || {};
      return cfg.label || cfg.name || p.key;
    },
    isDraftFilled(p) {
      return hasParamValue(this.draftValues[p.key], p.control);
    },
    openModal() {
      if (!this.editable) return;
      this.syncDraftFromValue();
      this.modalOpen = true;
    },
    onModalVisible(visible) {
      if (visible) this.syncDraftFromValue();
    },
    syncDraftFromValue() {
      const draft = {};
      const src = (this.value && typeof this.value === 'object') ? this.value : {};
      this.paramDefs.forEach((p) => {
        const cur = src[p.key];
        if (cur !== undefined) {
          draft[p.key] = cloneDeep(cur);
        } else {
          draft[p.key] = defaultValueFor(p.control, p.config);
        }
      });
      this.draftValues = draft;
    },
    setDraftValue(key, val) {
      this.$set(this.draftValues, key, val);
    },
    buildOutput(draft) {
      const out = {};
      this.paramDefs.forEach((p) => {
        const v = draft[p.key];
        if (hasParamValue(v, p.control)) {
          out[p.key] = cloneDeep(v);
        }
      });
      return out;
    },
    ensureValueShape() {
      if (!this.paramDefs.length) return;
      const src = (this.value && typeof this.value === 'object') ? this.value : {};
      const next = { ...src };
      let changed = false;
      this.paramDefs.forEach((p) => {
        if (next[p.key] === undefined && p.config && p.config.default !== undefined) {
          next[p.key] = cloneDeep(p.config.default);
          changed = true;
        }
      });
      if (changed) this.$emit('input', next);
    },
    handleSave() {
      const out = this.buildOutput(this.draftValues);
      this.$emit('input', Object.keys(out).length ? out : undefined);
      this.modalOpen = false;
    },
    handleClear() {
      this.$emit('input', undefined);
      this.modalOpen = false;
    },
    handleCancel() {
      this.modalOpen = false;
    },
  },
};
</script>
